var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHardDrives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6599 6.75H9.65991C8.66535 6.75 7.71152 7.14509 7.00826 7.84835C6.305 8.55161 5.90991 9.50544 5.90991 10.5V37.5C5.90991 38.4946 6.305 39.4484 7.00826 40.1516C7.71152 40.8549 8.66535 41.25 9.65991 41.25H39.6599C40.6545 41.25 41.6083 40.8549 42.3116 40.1516C43.0148 39.4484 43.4099 38.4946 43.4099 37.5V10.5C43.4099 9.50544 43.0148 8.55161 42.3116 7.84835C41.6083 7.14509 40.6545 6.75 39.6599 6.75ZM38.9099 11.25V21.75H10.4099V11.25H38.9099ZM10.4099 36.75V26.25H38.9099V36.75H10.4099ZM30.6599 16.5C30.6599 15.9067 30.8359 15.3266 31.1655 14.8333C31.4951 14.3399 31.9637 13.9554 32.5119 13.7284C33.06 13.5013 33.6632 13.4419 34.2452 13.5576C34.8271 13.6734 35.3617 13.9591 35.7812 14.3787C36.2008 14.7982 36.4865 15.3328 36.6023 15.9147C36.718 16.4967 36.6586 17.0999 36.4316 17.6481C36.2045 18.1962 35.82 18.6648 35.3266 18.9944C34.8333 19.3241 34.2533 19.5 33.6599 19.5C32.8643 19.5 32.1012 19.1839 31.5386 18.6213C30.976 18.0587 30.6599 17.2956 30.6599 16.5ZM36.6599 31.5C36.6599 32.0933 36.484 32.6734 36.1543 33.1667C35.8247 33.6601 35.3561 34.0446 34.808 34.2716C34.2598 34.4987 33.6566 34.5581 33.0746 34.4424C32.4927 34.3266 31.9581 34.0409 31.5386 33.6213C31.119 33.2018 30.8333 32.6672 30.7176 32.0853C30.6018 31.5033 30.6612 30.9001 30.8883 30.3519C31.1153 29.8038 31.4999 29.3352 31.9932 29.0056C32.4865 28.6759 33.0666 28.5 33.6599 28.5C34.4556 28.5 35.2186 28.8161 35.7812 29.3787C36.3438 29.9413 36.6599 30.7044 36.6599 31.5Z",
    fill: "url(#paint0_linear_1559_3818)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_3818",
    x1: 24.6599,
    y1: 6.75,
    x2: 24.6599,
    y2: 41.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardDrives);
export default __webpack_public_path__ + "static/media/HardDrives.3f7667deed410253c8f509f8dd2fcb5f.svg";
export { ForwardRef as ReactComponent };